<template>
    <router-link :to="to" :title="label" v-if="isSpa">
        <slot><span v-text="label"/></slot>
    </router-link>
    <a class="conditional-link"
            rel="noopener noreferrer"
            :href="routerLink"
            :title="label"
            v-else>
        <slot><span v-text="label"/></slot>
    </a>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                default: '',
            },
            to: {
                type: [Object, String],
                required: true,
            },
        },
        data() {
            return {
                isSpa: globals.config.router.isSpa,
            };
        },
        computed: {
            routerLink() {
                if (typeof this.to === 'string') {
                    return this.to;
                }

                const { resolved } = this.$router.resolve(this.to);

                if (resolved) {
                    return resolved.fullPath;
                }

                return this.to.path;
            },
        },
    };
</script>
